var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block import-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "postForm",
    staticClass: "demo-form",
    attrs: {
      model: _vm.postForm,
      "status-icon": "",
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-upload", {
    staticClass: "upload-demo",
    attrs: {
      action: "",
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed,
      accept: _vm.acceptableFormats.join(", "),
      "auto-upload": false
    },
    model: {
      value: _vm.postForm.file,
      callback: function ($$v) {
        _vm.$set(_vm.postForm, "file", $$v);
      },
      expression: "postForm.file"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "warning",
      loading: _vm.fileExcelToJsonProgressing,
      disabled: _vm.processingProduct
    }
  }, [_vm._v(" Click to Upload ")])], 1), _c("br"), _vm.fileExcelToJsonProgressing ? [_c("el-skeleton", {
    attrs: {
      animated: ""
    }
  }), _c("br")] : _vm._e(), _vm.productData && _vm.productData.length ? [_c("el-divider", [_c("i", {
    staticClass: "el-icon-star-on"
  })]), _vm.fileRead && _vm.productData.length > 0 ? [_c("div", {
    staticClass: "centered-count"
  }, [_vm.currentlyProcessingIndex < _vm.productData.length - 1 ? _c("div", [_c("el-button", {
    attrs: {
      type: "success",
      icon: "el-icon-video-play",
      disabled: _vm.processingProduct
    },
    on: {
      click: _vm.processProduct
    }
  }, [_vm._v(" Process ")]), _c("el-button", {
    attrs: {
      type: "warning",
      icon: "el-icon-video-play",
      disabled: _vm.processingProduct
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(" Reset ")]), _c("el-button", {
    attrs: {
      type: "danger",
      icon: "el-icon-video-pause",
      disabled: _vm.pauseProcessingProduct
    },
    on: {
      click: function ($event) {
        _vm.pauseProcessingProduct = true;
      }
    }
  }, [_vm._v(" Pause ")])], 1) : _vm._e(), _c("br"), _c("el-progress", {
    attrs: {
      "text-inside": true,
      "stroke-width": 24,
      percentage: parseFloat((_vm.processedProducts * 100 / _vm.productData.length).toFixed(2)),
      status: "success"
    }
  }), _vm.currentlyProcessingIndex > -1 ? _c("p", [_vm._v(" currently processing sr#: " + _vm._s(_vm.currentlyProcessingIndex + 1) + " ")]) : _vm._e(), _c("br"), _c("el-row", {
    attrs: {
      gutter: 12
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-card", {
    attrs: {
      shadow: "hover"
    }
  }, [_vm._v(" Total: " + _vm._s(_vm.productData.length) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-card", {
    attrs: {
      shadow: "hover"
    }
  }, [_vm._v(" Processed: " + _vm._s(_vm.processedProducts) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-card", {
    attrs: {
      shadow: "hover"
    }
  }, [_vm._v(" Failed: " + _vm._s(_vm.failedProducts) + " "), _c("br")])], 1)], 1)], 1)] : _vm._e(), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.productData,
      border: "",
      height: "500",
      size: "mini"
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "S No"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "Name",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.name) + " ")];
      }
    }], null, false, 2507105690)
  }), _c("el-table-column", {
    attrs: {
      prop: "productType",
      label: "Type",
      width: "70"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "category",
      label: "Category",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "attributesValues",
      label: "Attributes",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "mrp",
      label: "MRP",
      width: "80"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "file",
      label: "Image",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.file ? [scope.row.imageLoaded ? [_c("el-image", {
          staticStyle: {
            width: "100px"
          },
          attrs: {
            src: scope.row.file,
            lazy: ""
          }
        }, [_c("div", {
          staticClass: "image-slot",
          attrs: {
            slot: "placeholder"
          },
          slot: "placeholder"
        }, [_vm._v(" Loading"), _c("span", {
          staticClass: "dot"
        }, [_vm._v("...")])]), _c("div", {
          staticClass: "image-slot",
          attrs: {
            slot: "error"
          },
          slot: "error"
        }, [_c("i", {
          staticClass: "el-icon-picture-outline"
        })])])] : [_vm._v(" upload prev rows ")]] : [_c("input", {
          staticClass: "filter-item",
          attrs: {
            size: "mini",
            type: "file",
            disabled: scope.row.uploadStatus === "uploaded"
          },
          on: {
            change: function ($event) {
              return _vm.getImageIntoBase64($event, scope);
            }
          }
        })]];
      }
    }], null, false, 2460211800)
  }), _c("el-table-column", {
    attrs: {
      prop: "action",
      label: "Action",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.file || scope.row.uploadStatus === "uploaded" ? [_c("el-tag", {
          attrs: {
            type: _vm.getUploadStatusType(scope.row.uploadStatus),
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.uploadStatus) + " ")]), scope.row.uploadStatus === "failed" ? _c("div", [_vm._v(" " + _vm._s(scope.row.failedReason) + " ")]) : _vm._e()] : [_vm._v(" Image not found ")]];
      }
    }], null, false, 60968242)
  })], 1), _c("br"), _c("br")] : _vm._e()], 2)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };